import { getSmartPageUrlSuffix } from '@bingads-webui-campaign/smart-page-url-suffix-provider';

const SmartPageUrlSuffix = getSmartPageUrlSuffix(document.domain);

export const getSmartPageUrl = (subdomain = '', siteSuffix = '') => {
  if (siteSuffix) {
    return `https://${subdomain}${SmartPageUrlSuffix}/${siteSuffix}`;
  }

  return `https://${subdomain}${SmartPageUrlSuffix}`;
};

export const getCustomDomain = domainDetail => (domainDetail && domainDetail.CustomDomain) || '';

export const addHttps = domain => `https://${domain}`;

export const getSmartPageUrlOrCustomDomain = ({
  subdomain = '',
  siteSuffix = '',
  domainDetail = {},
  isSmartPageCustomDomainEnabled = false,
} = {}) => {
  const spUrl = getSmartPageUrl(subdomain, siteSuffix);
  const customDomain = getCustomDomain(domainDetail);
  const customUrl = customDomain && addHttps(customDomain);

  return isSmartPageCustomDomainEnabled ? (customUrl || spUrl) : spUrl;
};
